import { render, staticRenderFns } from "./SamplesForm.vue?vue&type=template&id=53bd6223&"
import script from "./SamplesForm.ts?vue&type=script&lang=ts&"
export * from "./SamplesForm.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports